module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tutor-box"
  }, [(this.start_teach) ? _c('div', [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container col-md-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.start_teach = false;
        _vm.before_startTour_modal = true;
      }
    }
  }, [_vm._v("\n                  開始個人教學\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.startBuildTeam()
      }
    }
  }, [_vm._v("\n                  開始建立團隊，邀請夥伴\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.startJoinTeam()
      }
    }
  }, [_vm._v("\n                  如何加入夥伴的團隊\n                ")])])])])])])])]) : _vm._e(), _vm._v(" "), (this.build_team_modal) ? _c('div', [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container col-md-8"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms col-md-12"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.build_team_modal = false;
        _vm.start_teach = true
      }
    }
  }, [_vm._v("\n                返回上一頁\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.build_team_modal = false;
        _vm.before_startTour_modal = true;
      }
    }
  }, [_vm._v("\n                下一步\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (this.join_team_modal) ? _c('div', [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container col-md-8"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-left"
  }, [_c('ol', [_c('li', [_vm._v("告訴你的邀請人你的Email「" + _vm._s(_vm.user.email) + "」，請他邀請您，系統將會寄送邀請信，到您的信箱給您。")]), _vm._v(" "), _c('li', [_vm._v("到您的信箱，收取邀請信，點擊邀請連結，即可完成加入。")]), _vm._v(" "), _c('li', [_vm._v("加入完成後，您的相關設定將會套用新團隊的設定")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms col-md-12"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.join_team_modal = false;
        _vm.start_teach = true
      }
    }
  }, [_vm._v("\n                返回上一頁\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.join_team_modal = false;
        _vm.before_startTour_modal = true;
      }
    }
  }, [_vm._v("\n                下一步\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (this.before_startTour_modal) ? _c('div', [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container col-md-8"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms col-md-12"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.before_startTour_modal = false;
        _vm.startTour();
      }
    }
  }, [_vm._v("\n                開始導覽\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), _c('v-tour', {
    attrs: {
      "options": _vm.myOptions,
      "name": "myTour",
      "steps": _vm.personal_steps,
      "callbacks": _vm.personalStepCallBack
    }
  }), _vm._v(" "), _c('v-tour', {
    attrs: {
      "options": _vm.myOptions,
      "name": "buildTeamTour",
      "steps": _vm.build_team_steps,
      "callbacks": _vm.buildTeamStepCallBack
    }
  }), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("歡迎來到Flowneat,準備開始進行您的銷售管理！")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', [_vm._v("個人使用")]), _vm._v(" "), _c('h1', [_c('i', {
    staticClass: "fas fa-user"
  })]), _vm._v(" "), _c('p', [_vm._v("我是個人使用，不會有夥伴需要馬上加入")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', [_vm._v("建立團隊")]), _vm._v(" "), _c('h1', [_c('i', {
    staticClass: "fas fa-wrench"
  })]), _vm._v(" "), _c('p', [_vm._v("我需要建立一個團隊，讓整體團隊使用，並邀請團隊成員加入")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', [_vm._v("加入團隊")]), _vm._v(" "), _c('h1', [_c('i', {
    staticClass: "fas fa-users"
  })]), _vm._v(" "), _c('p', [_vm._v("我需要加入已經存在的團隊")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("如何邀請新夥伴")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body text-left"
  }, [_c('ol', [_c('li', [_vm._v("請您的新夥伴註冊Flowneat，並完成信箱驗證。")]), _vm._v(" "), _c('li', [_vm._v("你可以透過『團隊管理功能』，輸入您的夥伴Email邀請他加入")]), _vm._v(" "), _c('li', [_vm._v("您的夥伴將會收到邀請Email，請夥伴點擊接收即可加入！")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("透過以下流程，你就可以成功加入團隊")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("我們將帶領你快速了解如何使用Flowneat")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('h5', [_vm._v("只要3分鐘，您就能了解如何使用Flowneat，管理交易、建立報價單、管理聯絡人、分析業務...等等重要功能。")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('h1', [_c('i', {
    staticClass: "fa fa-file-invoice-dollar"
  })]), _vm._v(" "), _c('p', [_vm._v("交易管理")])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('h1', [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v(" "), _c('p', [_vm._v("客戶管理")])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('h1', [_c('i', {
    staticClass: "fas fa-chart-line"
  })]), _vm._v(" "), _c('p', [_vm._v("業績管理")])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('h1', [_c('i', {
    staticClass: "far fa-calendar-alt"
  })]), _vm._v(" "), _c('p', [_vm._v("代辦事項管理")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21c02b38","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/TutorSteps.vue
// module id = 673
// module chunks = 4